export const STAFF_EVENT_USER = 'STAFF_EVENT_USER'
export const ADMIN_EVENT_USER = 'ADMIN_EVENT_USER'
export const STAFF_MANAGE_TOKEN = 'STAFF_MANAGE_TOKEN'
export const STAFF_MANAGE_LOCALE = 'STAFF_MANAGE_LOCALE'
export const STAFF_MANAGE_TRANSALATION = 'STAFF_MANAGE_TRANSALATION'

export const ADMIN_ACCOUNT = {
    username: 'admin',
    password: '12345678'
}

export const FRANK_ACCOUNT = {
    username: 'frankfurt',
    password: 'Shoptogo2024'
}

export const areaTabs = [
    {
        key: '1',
        label: 'Frankfurt',
    },
    {
        key: '2',
        label: 'Stuttgart',
    },
    {
        key: '3',
        label: 'Saarbruecken',
    },
    {
        key: '4',
        label: 'Heidelberg',
    },
];